import { useState } from "react";
import "./modal.scss";

import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "react-multi-date-picker/styles/layouts/prime.css";
import styles from "../campain.module.css";
import { FaPlusCircle } from "react-icons/fa";
import makeAnimated from "react-select/animated";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import { MdAddCircleOutline } from "react-icons/md";
import { MdRemoveCircleOutline } from "react-icons/md";
function AddCampain({ customers, Update }) {
  const animatedComponents = makeAnimated();
  const [inputFields, setInputFields] = useState([{ nameField: "" }]);
  const allStep = [
    "اول",
    "دوم",
    "سوم",
    "چهارم",
    "پنجم",
    "ششم",
    "هفتم",
    "هشتم",
    "نهم",
    "دهم",
  ];
  const handleChangeInput = (index, event) => {
    const values = [...inputFields];
    values[index][event.target.name] = event.target.value;
    setInputFields(values);
  };
  const handleAddFields = () => {
    setInputFields([...inputFields, { nameField: "" }]);
  };
  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
  };
  return (
    <>
      <div
        className="modal fade"
        id={`exampleModalAdd`}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        dir="rtl"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header ">
              <h5 className="modal-title" id="edit-userLabel">
                اضافه کردن کمپین
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="edit-user-container">
                <form id="edit-user-form-data" className=" edit-container">
                  <div className="d-flex justify-content-between">
                    <p className="mt-2 w-50 textsmall">انتخاب کالا یا خدمات</p>
                    <Select
                      className="inputModal2"
                      // value={customers[index].barchasb}
                      // onChange={changeHandlerDaste}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti={true}

                      // options={optionDasteBandi}
                    />
                  </div>
                  <div className="d-flex justify-content-between">
                    <p className="mt-2 w-50 textsmall"> دسته بندی مشتری</p>
                    <CreatableSelect
                      className="inputModal2"
                      // value={customers[index].barchasb}
                      // onChange={changeHandlerDaste}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti={true}

                      // options={optionDasteBandi}
                    />
                  </div>
                  <div className="d-flex justify-content-between">
                    <p className="mt-2 w-50 textsmall">عنوان</p>
                    <input className={styles.inputModal} type="text" />
                  </div>
                  <div className="d-flex justify-content-between">
                    <p className="textDateBox textsmall"> زمان شروع </p>
                    <div className="boxDate">
                      <DatePicker
                        className="rmdp-prime"
                        showOtherDays
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <p className="textDateBox textsmall"> زمان پایان </p>
                    <div className="boxDate">
                      <DatePicker
                        className="rmdp-prime"
                        showOtherDays
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-between ">
                    <p className="textDateBox textsmall"> توضیحات </p>
                    <textarea className={styles.inputModal} type="text" />
                  </div>
                  {inputFields.map((inputField, index) => (
                    <div
                      key={index}
                      className="d-flex justify-content-between "
                    >
                      <p className="mt-2 w-50 textsmall">{`تعریف مرحله  ${allStep[index]}`}</p>
                      <div className="w-100 d-flex">
                        <input
                          className={styles.inputModal}
                          value={inputField.nameField}
                          onChange={(event) => handleChangeInput(index, event)}
                          name="nameField"
                        />
                        <div
                          className="d-flex justify-content-evenly align-items-center "
                          style={{
                            width: "50px",
                            fontSize: "20px",
                            color: "#333",
                            cursor: "pointer",
                          }}
                        >
                          <MdAddCircleOutline onClick={handleAddFields} />
                          {index != 0 && (
                            <MdRemoveCircleOutline
                              onClick={() => handleRemoveFields(index)}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </form>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  Update(customers);
                }}
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddCampain;
{
  /* <input
type="text"
className="form-control"
value={customers[index].status}
onChange={(e) =>
  EditUser((prev) => {
    let temp = [...prev];
    temp[index][e.target.name] = e.target.value;
    return [...temp];
  })
}
name="status"
id="address-edit-user"
/>
</div> */
}
